import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { TranslationService, UserService } from '@lciapps/lci-core';
import { FeatureService } from '../feature.service';
import { AppSettings } from '../features/activities/shared/models/app-setting.enum';
import { UserClaim } from '../features/activities/shared/models/user-claim.enum';
import { IeNoSupportComponent } from './ie-no-support/ie-no-support.component';

@Component({
  selector: 'app-root',
  template: `
    <div class="container">
      <app-auth-nav></app-auth-nav>
      <ng-container *ngIf="signalRSwitch == 'ON'">
      <app-application-alerts></app-application-alerts>
      </ng-container>
      <link-bar (navTo)="navigateTo($event)" [applications]="applications" [links]="links"></link-bar>
      <div style="padding-left: 15px; padding-right: 15px; display: block;">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  `,
  styles: [
    `
      .container {
        padding-left: 0;
        padding-right: 0;
      }
    `
  ]
})
export class RootComponent implements OnInit {
  public links = [];

  applications: any = [];
  signalRSwitch;
  UserDetails: any = [];

  constructor(
    private translationService: TranslationService,
    private router: Router,
    private featureService: FeatureService,
    private userService: UserService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.featureService.getApplicationSettings().subscribe(res => {
      if (res) {
        res.forEach((app) => {
          if (app.applicationName == AppSettings.appName && app.settingName == AppSettings.signalR) {
            this.signalRSwitch = app.configuredValue;
          }
        });
      }
    })

    this.featureService.getMenuLinks().subscribe(res => {
      this.links = res;

      if (this.links.length > 0) {
        this.translationService.getTranslationValue('btnHome')
          .subscribe(val => {
            this.links[0].label = val;
          });
        this.translationService.getTranslationValue('lblNewActivity')
          .subscribe(val => {
            this.links[2].label = val;
          });
        this.translationService.getTranslationValue('lblReportActivity')
          .subscribe(val => {
            this.links[1].label = val;
          });
        this.translationService.getTranslationValue('lblActivitiesLC')
          .subscribe(val => {
            this.links[3].label = val;
          });
        this.translationService.getTranslationValue('lblDashboard')
          .subscribe(val => {
            this.links[4].label = val;
          });
      }
    });

    this.userService.getMe().subscribe(m => {
      this.UserDetails = m;
      this.featureService.getApplications(m.id).subscribe(apps => {
        apps.find((app) => {
          if (app.applicationName != UserClaim.MyLion) {
            if (this.UserDetails.userProfile.country != UserClaim.Country && app.applicationName != UserClaim.ShopJapan) {
              this.applications.push(app);
            }
            if (this.UserDetails.userProfile.country == UserClaim.Country && app.applicationName != UserClaim.Shop) {
              this.applications.push(app);
            }
          }
        });
      });
    });
    setTimeout(() => {
      this.detectBrowserSupport();
    }, 1000);
  }

  public navigateTo(site: string): void {
    switch (site) {
      case 'mylci':
        this.featureService.getSSO().subscribe(res => {
          window.location.href = `${res.redirectUrl}?token=${res.token}`;
        });
        return;
      // window.location.href = 'https://mylci.lionsclubs.org';
      // break;
      case 'mylion':
        this.router.navigate(['/']);
        break;
      case 'ourwebsite':
        window.location.href = 'https://lionsclubs.org';
        break;
    }
  }

  private detectBrowserSupport() {
    if (this.isIE()) {
      const dialogRef = this.dialog.open(IeNoSupportComponent, {
        panelClass: 'mat-dialog-large',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((result) => { });
    }
  }

  /** Check if the browser is IE */
  private isIE(): any {
    return window.navigator.userAgent.match(/(MSIE|Trident)/);
  }
}
